// surveyDataTableView.js
import axios from "axios";

export async function getSurveyDataTableView(
  selectedScheme,
  stateCodeValue,
  finacialYearValue
) {
  const apiurl = "/api/LatLongPolygonList/CompleteFarmerData_KM";
  //alert(finacialYearValue);
  // ✅ Financial year mapping
  const finYearMap = {
    "2025": "2025-2026",
    "2024": "2024-2025",
    "2023": "2023-2024",
  };

  const finYear = finYearMap[finacialYearValue] || "";

  // ✅ Scheme code mapping
  const schemeCodeMap = {
    "RKVY (Bhuvan)": "15",
    "RKVY DPR": "15",
    "(RKVY DPR) SD": "15",
    "(RKVY DPR) FLD": "15",
    "(RKVY DPR) CFLD": "15",
    "Mission for Integrated Development of Horticulture (MIDH)": "8",
    "(MIDH) SD": "8",
    "(MIDH) FLD": "8",
    "(MIDH) CFLD": "8",
    "Per Drop More Crop(PDMC)": "1",
    "Ground Truthing (GT)": "12",
    "GT": "12",
    "Rainfed Area Development": "2",
    "Crop Health": "13",
    "Crop Health (CH)": "13",
    "MOVCD": "9",
    "Mission Organic Value Chain Development (MOVCD)": "9",
    "(MoVCD) SD": "9",
    "(MoVCD) FLD": "9",
    "(MoVCD) CFLD": "9",
    "Agroforestry": "3",
    "Coconut Development Board (CDB)": "10",
    "National Mission on Edible Oils (NMEO)-OS": "5",
    "National Mission on Edible Oils (NMEO)-OP": "14",
    "Agri Infra Fund": "24",
    "National Bamboo Mission": "21",
    "PKVY": "22",
    "Directorate of Arecanut and Spices Development (DASD)": "11",
    "Natural Farming(NF)": "6",
    "M&T - CHC (Farms App)": "37",
    "Soil Health Card (SHC)-Farmer": "31",
    "MT-CRM": "40",
    "MT-SMAM": "27",
    "National Horticulture Board (NHB)-Inspection": "32",
    "Seed Hub": "29",
    "Agriculture Marketing Infrastructure (AMI)": "33",
    "Agriculture Marketing Infrastructure()": "33",
  };

  const SchemeCodeVal = schemeCodeMap[selectedScheme] || "";

  try {
    const payload = {
      SchemeCode: SchemeCodeVal,
      finYear: finYear,
      stateCode: stateCodeValue||"0",
      districtCode: "0",
      subDistrictCode: "0",
    };

    const baseURL =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEV_MODE
        : process.env.REACT_APP_PRO_MODE;

    const response = await axios.post(`${baseURL}${apiurl}`, payload);

    return response.data?.dataContent || [];
  } catch (error) {
    console.error("API ERROR:", error);
    return [];
  }
}
